"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSeoFriendlyCategoryName = exports.getCategoryProperty = void 0;
const createDataLayerObject_1 = __importDefault(require("./createDataLayerObject"));
const getCategoryProperty_1 = __importDefault(require("./utils/getCategoryProperty"));
exports.getCategoryProperty = getCategoryProperty_1.default;
const getSeoFriendlyCategoryName_1 = __importDefault(require("./utils/getSeoFriendlyCategoryName"));
exports.getSeoFriendlyCategoryName = getSeoFriendlyCategoryName_1.default;
exports.default = createDataLayerObject_1.default;
//# sourceMappingURL=index.js.map